const BasePlugin = require('./basePlugin');
const leafletMithrilControl = require('./mithrilControl'); // important
const pathHeader = require('../../layout/components/pathHeader');
const edit = require('../../layout/components/edit');

class navOverlayPlugin extends BasePlugin {
  constructor(ctrl) {
    super(ctrl);
    this.ctrl.eventBus.on('mithril:oncreate', () => {
      // Mithril components
      this.navStatus = new L.Control.MithrilControl({
        position: 'topleft'
      });

      this.ctrl.map.whenReady(() => {
        this.ctrl.map.addControl(this.navStatus);
        this.ctrl.map.on('fullscreenchange', this.updateOverlay);
        // Initial decide based on fullscreen or explicit flag
        this.updateOverlay();
      });
    });
    
    // Keep overlay state synced on updates
    this.ctrl.eventBus.on('mithril:onupdate', () => {
      this.updateOverlay();
    });
  }

  loadMithrilComponents = () => {
    if (!this.navStatus._map) {
      this.navStatus.addTo(this.ctrl.map);
    }
    // If an equipment record is present (equipmentDetail page), append it to the path
    let recordForHeader = this.ctrl.location();
    let ancestorsForHeader = this.ctrl.ancestors();
    try {
      const eqRec = typeof this.ctrl.equipmentRecord === 'function' ? this.ctrl.equipmentRecord() : this.ctrl.equipmentRecord;
      if (eqRec && eqRec['@rid']) {
        recordForHeader = eqRec;
        ancestorsForHeader = [...(Array.isArray(ancestorsForHeader) ? ancestorsForHeader : []), eqRec];
      }
    } catch (e) {
      // fall back silently
    }

    this.navStatus.mountMithrilComponent(pathHeader, {record: recordForHeader, ancestors: ancestorsForHeader});
  }
  
  unloadMithrilComponents = () => {
    this.navStatus.remove();
  }

  updateOverlay = () => {
    if (!this.ctrl?.map) return;
    const isFull = this.ctrl.map.isFullscreen && this.ctrl.map.isFullscreen();
    const shouldShow = isFull || !!this.ctrl.showPathOverlay;

    if (shouldShow) {
      // If fullscreen, do the geoman control hack
      if (isFull && this.ctrl.map?.pm?.removeControls) {
        this.ctrl.map.pm.removeControls();
      }
      this.loadMithrilComponents();
      if (isFull && edit.vm.editing() && this.ctrl.map?.pm?.addControls) {
        this.ctrl.map.pm.addControls();
      }
    } else {
      this.unloadMithrilComponents();
    }
  }
}

module.exports = navOverlayPlugin;
